import React, { useContext, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import AddSettlement from './AddSettlement'
import HeaderComponent from 'components/HeaderComponent'
import MaterialTable from '@material-table/core'
// import Icons from 'includes/Icons'
import { getResponse, previewModal } from 'store/slices/miscSlice'
import { useDispatch, useSelector } from 'react-redux'
import { SettlementContext } from '../settlementContext'
import Spinner from 'components/Spinner'
import { mutate } from 'swr'

function SettlementTable({ t, settlement_bank, online }) {
    const settlement = () => {
        dispatch(previewModal({
            title: t('settings.bank_settlement.title'), content: () => <AddSettlement />
        }));
        dispatch(getResponse(`adding_pos_${Math.random()}`))
    }

    const { response } = useSelector(state => state?.misc)
    useEffect(() => {
        mutate('settings/settlement-banks')
    }, [response])
    const dispatch = useDispatch()
    const { edit } = useContext(SettlementContext)
    return (
        <section className={`w-full bg-white p-8 rounded-xl mb-5 shadow-sm ${edit.editState ? 'hidden' : ''}`}>
            {
                online ? <MaterialTable
                    title=''
                    columns={[
                        { title: 'Bank name', field: 'bank_name' },
                        { title: 'Account name', field: 'account_name' },
                        { title: 'Account number', field: 'account_number' },
                    ]}
                    options={{
                        actionsColumnIndex: -1.
                    }}
                    localization={{
                        header: {
                            actions: ''
                        }
                    }}
                    // actions={[
                    //     {
                    //         icon: () => <UIcons.UilPen className="text-primary" />,
                    //         tooltip: 'View details',
                    //         onClick: (click, data) => setEdit({ ...edit, editState: !edit.editState, editId: data.tableData.index })
                    //     }
                    // ]}
                    data={
                        [settlement_bank?.data[0]] ?? []
                    }
                    icons={''}
                    // icons={Icons}
                    components={{
                        Toolbar: props => (
                            <div className="mb-5">
                                <HeaderComponent
                                    title="Settlement banks"
                                    btnText={t('settings.bank_settlement.add')}
                                    // btnText={`${settlement_bank?.data ? t('settings.bank_settlement.edit') : t('settings.bank_settlement.add')}`} 
                                    btnClick={settlement}
                                    hideBtn={settlement_bank?.data.length > 1}
                                />
                            </div>
                        ),
                    }}
                /> : <Spinner />
            }
        </section>
    )
}

export default withTranslation()(SettlementTable)